import blocksConfig from '@assets/config/blocks.json';

const imageModules = import.meta.glob('/assets/images/blocks/season2/*.png', {
  eager: true,
  import: 'default',
}) as Record<string, string>;

const svgModules = import.meta.glob('/assets/images/blocks/season2/*.svg', {
  eager: true,
  import: 'default',
}) as Record<string, string>;

/**
 * import.meta.glob のキー（例: `/assets/images/blocks/01.png`）を
 * blocks.json 内の相対パス（例: `images/blocks/01.png`）に正規化したマップ
 */
const createPathMap = (
  modules: Record<string, string>,
): Record<string, string> => {
  const map: Record<string, string> = {};
  for (const [key, value] of Object.entries(modules)) {
    const relativePath = key.replace(/^\/?assets\//, '');
    map[relativePath] = value;
  }
  return map;
};

/** blocks.json の imagePath → ビルド後URL */
export const imagePathMap = createPathMap(imageModules);

/** blocks.json の verticesPath → ビルド後URL */
export const svgPathMap = createPathMap(svgModules);

/** blockId → ビルド後の画像URL */
export const blockImageMap: Record<number, string> = blocksConfig.reduce<
  Record<number, string>
>((acc, config) => {
  const resolved = imagePathMap[config.imagePath];
  if (resolved) {
    acc[config.id] = resolved;
  }
  return acc;
}, {});
